import {
  Factory,
  ClipboardList,
  Settings,
  FileText,
  Handshake,
} from 'lucide-react';

import { InboundTollingListView } from './_components/inbound-tolling/_InboundTollingListView';
import { OutboundTollingListView } from './_components/outbound-tolling/_OutboundTollingListView';
import { ProcessingTypesListView } from './_components/processing-types/_ProcessingTypesListView';
import { WorkOrderDetailView } from './_components/work-orders/_WorkOrderDetailView';
import { WorkOrdersListView } from './_components/work-orders/_WorkOrdersListView';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

const basePath = '/production';

export const productionRoutes = createModuleRoutes({
  root: {
    path: basePath,
    label: (t) => t.menu.production.root,
    icon: Factory,
  },
  workOrders: {
    path: `${basePath}/work-orders` as const,
    label: (t) => t.menu.production.workOrders,
    icon: ClipboardList,
    component: WorkOrdersListView,
    requiredPermission: 'workOrderRead',
  },
  workOrderDetail: {
    path: `${basePath}/work-orders/:workOrderId` as const,
    component: WorkOrderDetailView,
  },
  processingTypes: {
    path: `${basePath}/processing-types` as const,
    label: (t) => t.menu.production.processingTypes,
    icon: Settings,
    component: ProcessingTypesListView,
    requiredPermission: 'processingTypeRead',
  },
  outboundTolling: {
    path: `${basePath}/outbound-tolling` as const,
    label: (t) => t.menu.production.tollAgreements,
    icon: FileText,
    component: OutboundTollingListView,
    requiredPermission: 'outboundTollingAgreementRead',
  },
  inboundTolling: {
    path: `${basePath}/inbound-tolling` as const,
    label: (t) => t.menu.production.tollProcessingAgreements,
    icon: Handshake,
    component: InboundTollingListView,
    requiredPermission: 'inboundTollingAgreementRead',
  },
});

const productionNav = createModuleNav(($) =>
  $(productionRoutes.root, [
    $(productionRoutes.workOrders),
    $(productionRoutes.workOrderDetail),
    $(productionRoutes.processingTypes),
    $(productionRoutes.outboundTolling),
    $(productionRoutes.inboundTolling),
  ]),
);

export const productionModule = createAppModule({
  routes: productionRoutes,
  nav: productionNav,
  requiredEntitlement: 'production',
});
